import { FormControl, useToast } from "@chakra-ui/react";
import { format } from "date-fns";
import FormField from "../../../components/fields/FormField";
import FormModal from "../../../components/FormModal";
import { translate } from "../../../i18n";
import { CoachAvailabilityDto } from "../../../models/coach/dto/coach-availability.dto";
import { useAddCoachAvailabilities } from "../hooks/useAddCoachAvailabilities";

type Props = {
    isModalVisible: boolean;
    setIsModalVisible: (newValue: boolean) => void;
    onAvailabilitiesAdded: (items: CoachAvailabilityDto[]) => void;
    coachId: string;
    selectedTimeslot?: SelectedTimeSlotForBlockadeProps;
};
export type SelectedTimeSlotForBlockadeProps = { startTime: Date; endTime: Date; coachId: string };
export default function CreateCoachAvailabilityModal({ coachId, selectedTimeslot, isModalVisible, onAvailabilitiesAdded, setIsModalVisible }: Props) {
    const toast = useToast();
    const { mutateAsync: addAvailabilities, isLoading: isCreatingBlockade } = useAddCoachAvailabilities((newAvailabilities) => {
        setIsModalVisible(false);
        onAvailabilitiesAdded(newAvailabilities);
    });

    if (!selectedTimeslot) return null;

    const handleSubmit = () => {
        addAvailabilities({
            coachId,
            availabilities: [{
                startTime: selectedTimeslot.startTime.toISOString(),
                endTime: selectedTimeslot.endTime.toISOString(),
            }]
        }).catch(() => {
            toast({ title: translate('error'), status: 'error', duration: 3000, position: 'top-right' });
        });
    };

    return (
        <FormModal
            isOpen={isModalVisible}
            onClose={() => setIsModalVisible(false)}
            title={translate('calendar.create_blockade_or_court_availability_modal.add_availability_mode_title')}
            onSubmit={handleSubmit}
            submitLabel={translate('submit')}
            isSubmitting={isCreatingBlockade}
            size="3xl"
        >
            <FormControl>
                <FormField
                    label={translate('event.start_date')}
                    value={format(new Date(selectedTimeslot.startTime), "dd MMMM yyyy HH:mm")}
                    isDisabled
                    onChange={() => {}}
                />
                <FormField
                    label={translate('event.end_date')}
                    value={format(new Date(selectedTimeslot.endTime), "dd MMMM yyyy HH:mm")}
                    isDisabled
                    onChange={() => {}}
                />
            </FormControl>
        </FormModal>
    )
}
